import { trackCustomEvent } from '../firebaseConfig';

/**
 * Utility function to track Zustand store actions
 * This can be used in any store to add analytics tracking to actions
 * 
 * @param actionName Name of the action (e.g., "login", "startInterview")
 * @param storeName Name of the store (e.g., "authStore", "interviewStore")
 * @param params Additional parameters to track (optional)
 */
export const trackStoreAction = (
  actionName: string, 
  storeName: string, 
  params: Record<string, any> = {}
) => {
  trackCustomEvent('store_action', {
    action_name: actionName,
    store_name: storeName,
    ...params
  });
};

export default trackStoreAction; 